import { render, staticRenderFns } from "./DataCard.vue?vue&type=template&id=8e380cb8&scoped=true"
import script from "./DataCard.vue?vue&type=script&lang=ts"
export * from "./DataCard.vue?vue&type=script&lang=ts"
import style0 from "./DataCard.vue?vue&type=style&index=0&id=8e380cb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_op2felhwcemqlmdmuodyzlbaea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e380cb8",
  null
  
)

export default component.exports